import React, { useState, useEffect } from 'react';
import api from '../services/api';
import PortalLayout, { card, StateMsg } from '../components/PortalLayout';

const A = '#00D4AA';

const ITEMS = [
  { key: 'tms_storing', titel: 'Nieuwe storingen', tekst: 'Melding zodra er een nieuwe storing op jouw wissels binnenkomt.' },
  { key: 'onderhoud_herinnering', titel: 'Onderhoud-herinnering', tekst: 'Melding 3 dagen voordat gepland onderhoud plaatsvindt.' },
  { key: 'werkorder_afgerond', titel: 'Werkorder afgerond', tekst: 'Melding wanneer een werkorder op jouw wissels is afgerond.' },
];

function Toggle({ aan, onClick }) {
  return (
    <button onClick={onClick} style={{ width: 48, height: 28, borderRadius: 999, border: 'none', background: aan ? A : '#cbd5e1', position: 'relative', cursor: 'pointer', flexShrink: 0 }}>
      <span style={{ position: 'absolute', top: 3, left: aan ? 23 : 3, width: 22, height: 22, borderRadius: 999, background: '#fff', transition: 'left .15s' }} />
    </button>
  );
}

export default function NotificatieVoorkeuren() {
  const [v, setV] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [opslaan, setOpslaan] = useState(false);

  useEffect(() => {
    api.get('/klantportaal/notificatie-voorkeuren')
      .then((r) => setV(r.data.voorkeuren))
      .catch(() => setError('Kon instellingen niet laden'))
      .finally(() => setLoading(false));
  }, []);

  const zet = async (key) => {
    const nieuw = { ...v, [key]: !v[key] };
    setV(nieuw);
    setOpslaan(true);
    try { await api.put('/klantportaal/notificatie-voorkeuren', nieuw); } catch (e) {}
    setOpslaan(false);
  };

  return (
    <PortalLayout titel="Meldingsinstellingen">
      <StateMsg loading={loading} error={error} />
      {v && (
        <>
          <p style={{ color: '#64748b', fontSize: 13, marginBottom: 14 }}>Kies waarover je een melding wilt ontvangen.</p>
          {ITEMS.map((it) => (
            <div key={it.key} style={{ ...card, display: 'flex', alignItems: 'center', gap: 14 }}>
              <div style={{ flex: 1 }}>
                <div style={{ fontWeight: 700, color: '#1e293b', fontSize: 15 }}>{it.titel}</div>
                <div style={{ color: '#64748b', fontSize: 13, marginTop: 2 }}>{it.tekst}</div>
              </div>
              <Toggle aan={!!v[it.key]} onClick={() => zet(it.key)} />
            </div>
          ))}
          <div style={{ color: '#94a3b8', fontSize: 12, textAlign: 'center', marginTop: 6, height: 16 }}>{opslaan ? 'Opslaan\u2026' : 'Opgeslagen'}</div>
        </>
      )}
    </PortalLayout>
  );
}
